import classNames from "classnames";
import React, { Dispatch, SetStateAction } from "react";

export interface HeadProps {
  title: string;
  label: string;
  locations: string[];
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  setHideDesc: Dispatch<SetStateAction<boolean>>;
}

export default function HeadSection({
  title,
  label,
  locations,
  activeTab,
  setActiveTab,
  setHideDesc,
}: HeadProps) {
  return (
    <>
      <p className="text-left text-main-red font-semibold mb-6 text-xl">
        {label}
      </p>
      <div className="flex justify-start overflow-auto flex-nowrap">
        {locations.map((tab: any) => (
          <p
            key={tab._uid}
            className={classNames(
              "text-main-black cursor-pointer font-semibold text-base min-w-[100px] text-center pb-4 transition duration-150 ease-in-out",
              activeTab === tab.title
                ? "text-main-blue border-b-2 border-b-[#2E3080]"
                : "text-main-neutrals border-b-2 border-b-[transparent]"
            )}
            onClick={() => {
              setHideDesc(true);
              setActiveTab(tab.title);
            }}
          >
            {tab.title}
          </p>
        ))}
      </div>
      <div className="hor-line -mt-[2px] lg:mb-9 mb-6" />
    </>
  );
}
